<template>
  <div>
    <FormSelect
      :name="props.name"

      v-model:selected="selected"
      :options="options"
      :displayOptions="displayOptions"
    >
    </FormSelect>
  </div>
  <div class="debug">
        <p>selected vmodel = {{ selected }}</p>
        <p>user options all = {{ options }} </p>
        <p>user display options all = {{ displayOptions }} </p>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import FormSelect from './Form-select.vue'
import { useUserStore } from '@/stores/user-store'
const userStore = useUserStore();
const props = defineProps({
  name: { type: String, default: 'Engineer:' },
  role: { type: String, default: 'engineer' },
  includeArchived: { type : Boolean, default: false}
})

const options = computed(() => {
 if(props.includeArchived === true){
  return optionsWithArchived.value.map(user => { return user.id})
 }else{
  return optionsWithArchived.value.filter(user => user.archived === false).map(user => { return user.id});
 }
})

const displayOptions = computed(() => {
 if(props.includeArchived === true){
  return optionsWithArchived.value.map(user => { return user.email})
 }else{
  return optionsWithArchived.value.filter(user => user.archived === false).map(user => { return user.email});
 }
})

const optionsWithArchived = computed (() =>{
  if (props.role == 'drafter') {
    return userStore.drafterOptions
  } else if (props.role == 'engineer'){
    return userStore.engOptions;
  } else{
    return userStore.ownerOptions;
  }
})

const selected = defineModel('selected') //, { required: true });
</script>
